import { Component } from '@angular/core';

@Component({
  selector: 'pm-emisores-list',
  templateUrl: './emisores-list.component.html',
  styleUrls: ['./emisores-list.component.sass']
})
export class EmisoresListComponent {
  public showEmisores = true;
  public showAddEmisor = false;
  public showEditEmisor = false;
  public editnumber = 0;
}
